import { FC } from 'react'
import styled from 'styled-components'
import { ShipmentsPeriodStatsBlock } from './shipments-period-stats-block'

const PaginationTotalBar = styled.div`
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
    gap: 20px;
    text-align: left;
`

interface ShipmentsPaginationTotalProps {
    total: number
}

export const ShipmentsPaginationTotal: FC<ShipmentsPaginationTotalProps> = ({ total }) => (
    <PaginationTotalBar>
        <ShipmentsPeriodStatsBlock />
        <span>{`Всего: ${total} шт.`}</span>
    </PaginationTotalBar>
)
